import React from 'react';
import { Table, Package, ChevronDown, ChevronUp } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент таблицы материалов для расчета плитки
 */
const MaterialsTable = ({ materials, showDetails, setShowDetails }) => {
  if (!materials || materials.length === 0) return null;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5 mt-8">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <Table className="w-5 h-5 mr-2 text-fuchsia-500" />
          Список материалов
        </h3>

        {/* Кнопка переключения подробностей */}
        <Button
          size="sm"
          onClick={() => setShowDetails(prev => !prev)}
          variant="outline"
          icon={showDetails ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          aria-expanded={showDetails}
        >
          {showDetails ? 'Скрыть подробности' : 'Показать подробности'}
        </Button>
      </div>

      {/* Информационная подсказка */}
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded p-3 mb-4 flex items-start">
        <Package className="text-blue-500 dark:text-blue-400 w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-blue-700 dark:text-blue-300">
          <p>В таблице представлены все необходимые материалы для выполнения работ по укладке плитки. 
             Расход материалов рассчитан по средним нормам для выбранного типа плитки и поверхности.</p>
        </div>
      </div>

      {/* Таблица материалов */}
      <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
        <table className="w-full text-sm text-left text-gray-700 dark:text-gray-300 min-w-full">
          <thead className="text-xs text-gray-700 dark:text-gray-300 uppercase bg-gray-100 dark:bg-gray-700">
            <tr>
              <th scope="col" className="px-4 py-2.5 font-semibold">Наименование</th>
              <th scope="col" className="px-4 py-2.5 font-semibold text-right">Количество</th>
              <th scope="col" className="px-4 py-2.5 font-semibold text-right">Упаковок</th>
              {showDetails && (
                <th scope="col" className="px-4 py-2.5 font-semibold text-right">Площадь</th>
              )}
              <th scope="col" className="px-4 py-2.5 font-semibold text-right">Цена</th>
              {showDetails && (
                <th scope="col" className="px-4 py-2.5 font-semibold">Примечания</th>
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {materials.map((material, index) => (
              <tr 
                key={material.type} 
                className={`${index % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-gray-50 dark:bg-gray-800/50'} 
                  hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors`}
              >
                <td className="px-4 py-3 font-medium whitespace-nowrap">
                  {material.name}
                </td>
                <td className="px-4 py-3 text-right whitespace-nowrap">
                  {material.quantity}
                </td>
                <td className="px-4 py-3 text-right whitespace-nowrap">
                  {material.packages}
                </td>
                {showDetails && (
                  <td className="px-4 py-3 text-right whitespace-nowrap">
                    {material.totalArea}
                  </td>
                )}
                <td className="px-4 py-3 text-right whitespace-nowrap font-medium">
                  {material.price}
                </td>
                {showDetails && (
                  <td className="px-4 py-3 text-gray-500 dark:text-gray-400">
                    {material.notes}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
          <tfoot className="text-xs text-gray-700 dark:text-gray-300 uppercase bg-gray-100 dark:bg-gray-700 font-semibold">
            <tr>
              <td className="px-4 py-2.5">Итого:</td>
              <td className="px-4 py-2.5 text-right">-</td>
              <td className="px-4 py-2.5 text-right">-</td>
              {showDetails && (
                <td className="px-4 py-2.5 text-right">-</td>
              )}
              <td className="px-4 py-2.5 text-right">
                {materials.reduce((sum, item) => 
                  sum + parseFloat(item.price.replace(/[^\d.-]/g, '')), 0).toFixed(2)} ₽
              </td>
              {showDetails && (
                <td className="px-4 py-2.5"></td>
              )}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default MaterialsTable;